import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

const duration = 200;

const resultContainerStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const resultTransitionStyles = {
  exiting: { opacity: 1 },
  entered: { opacity: 1 },
  exited: { opacity: 0, display: 'none' },
};

const ResultTransition = React.memo(({ transitionIn, children, style }) => {
  const nodeRef = React.useRef();
  return (
    <Transition nodeRef={nodeRef.current} in={transitionIn} timeout={duration} exit={false}>
      {(transitionState) => (
        <div ref={nodeRef} style={{ ...resultContainerStyle, ...resultTransitionStyles[transitionState], ...style }}>
          {children}
        </div>
      )}
    </Transition>
  );
});

ResultTransition.displayName = 'ResultTransition';
ResultTransition.propTypes = {
  transitionIn: PropTypes.bool,
  children: PropTypes.node.isRequired,
  style: PropTypes.object.isRequired,
};

ResultTransition.defaultProps = {
  transitionIn: false,
};

const Loader = ({ loaderComponent: LoaderComponent, isLoading, children, style }) => (
  <Fragment>
    <ResultTransition transitionIn={isLoading} style={style}>
      <LoaderComponent />
    </ResultTransition>
    <ResultTransition transitionIn={!isLoading} style={style}>
      {children}
    </ResultTransition>
  </Fragment>
);

Loader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  loaderComponent: PropTypes.elementType.isRequired,
  style: PropTypes.object,
};

Loader.defaultProps = {
  style: {},
};

export default Loader;
